/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Folder_LabelInputs */

const en_audio_description_export_folder_label = /** @type {(inputs: Audio_Description_Export_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Folder`)
};

const fr_audio_description_export_folder_label = /** @type {(inputs: Audio_Description_Export_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dossier d'exportation`)
};

const de_audio_description_export_folder_label = /** @type {(inputs: Audio_Description_Export_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportordner`)
};

const it_audio_description_export_folder_label = /** @type {(inputs: Audio_Description_Export_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartella di esportazione`)
};

const ru_audio_description_export_folder_label = /** @type {(inputs: Audio_Description_Export_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт папки`)
};

const es_audio_description_export_folder_label = /** @type {(inputs: Audio_Description_Export_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpeta de exportación`)
};

const zh_cn2_audio_description_export_folder_label = /** @type {(inputs: Audio_Description_Export_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出文件夹`)
};

const ja_audio_description_export_folder_label = /** @type {(inputs: Audio_Description_Export_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートフォルダ`)
};

const hi_audio_description_export_folder_label = /** @type {(inputs: Audio_Description_Export_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक्सपोर्ट फ़ोल्डर`)
};

const pt_pt2_audio_description_export_folder_label = /** @type {(inputs: Audio_Description_Export_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasta de exportação`)
};

/**
* | output |
* | --- |
* | "Export Folder" |
*
* @param {Audio_Description_Export_Folder_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_folder_label = /** @type {((inputs?: Audio_Description_Export_Folder_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Folder_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_folder_label(inputs)
	if (locale === "de") return de_audio_description_export_folder_label(inputs)
	if (locale === "it") return it_audio_description_export_folder_label(inputs)
	if (locale === "ru") return ru_audio_description_export_folder_label(inputs)
	if (locale === "es") return es_audio_description_export_folder_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_folder_label(inputs)
	if (locale === "ja") return ja_audio_description_export_folder_label(inputs)
	if (locale === "hi") return hi_audio_description_export_folder_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_folder_label(inputs)
	return en_audio_description_export_folder_label(inputs)
});